import { FC } from 'react';
import { Stack } from '@mui/material';
import MarkdownContent from '@/components/markdown-content';
import { AdditionalProperties } from '@/lib/models/user-event';
import Text from '@/components/text';
import { startCase } from 'lodash';
import { formatUnknownValueForDisplay } from '@/lib/value-format.helper';

interface Props {
  additionalProperties: AdditionalProperties;
}

const ToolContent: FC<Props> = ({ additionalProperties }) => {
  const { name = '', input = {} } = additionalProperties;
  const hasName = !!name;
  const hasInput = !!Object.keys(input).length;

  return (
    <Stack gap={0.5} className="dd-privacy-mask">
      {hasName && (
        <Stack direction="row" gap={1}>
          <Text size="small">Tool</Text>
          <MarkdownContent message={`\`${name}\``} />
        </Stack>
      )}
      {hasInput && (
        <Stack gap={1}>
          {Object.entries(input).map(([key, value]) => (
            <Stack key={key} direction="row" gap={1}>
              <Text size="small">{startCase(key)}</Text>
              <MarkdownContent message={`\`${formatUnknownValueForDisplay(value)}\``} />
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default ToolContent;
